export enum VehicleMake {
  Abarth = 0,
  Acura = 1,
  Aiways = 2,
  Aixam = 3,
  AlfaRomeo = 4,
  Alpine = 5,
  Aprilla = 6,
  ArcticCat = 7,
  AstonMartin = 8,
  Audi = 9,
  Austin = 10,
  Benalu = 11,
  Bentley = 12,
  Beta = 13,
  Bmw = 14,
  BmwAlpine = 15,
  Boic = 16,
  Bombardier = 17,
  Bova = 18,
  Bugatti = 19,
  Buick = 20,
  Cadillac = 21,
  Cagiva = 22,
  CanAm = 23,
  Chatenet = 24,
  Chevrolet = 25,
  Chrysler = 26,
  Citroen = 27,
  Cupra = 28,
  Dacia = 29,
  Daf = 30,
  Daihatsu = 31,
  Deawoo = 32,
  Dodge = 33,
  Doosan = 34,
  DsAutomobiles = 35,
  Ducati = 36,
  Fendt = 37,
  Ferrari = 38,
  Fiat = 39,
  Ford = 40,
  Fuso = 41,
  Gaz = 42,
  Geely = 43,
  Gem = 44,
  Genesis = 45,
  Gilera = 46,
  Gm = 47,
  Gmc = 48,
  HarleyDavidson = 49,
  Honda = 50,
  Hummer = 51,
  Husqvarna = 52,
  Hyundai = 53,
  Indian = 54,
  Infiniti = 55,
  Irisbus = 56,
  Irizar = 57,
  Isuzu = 58,
  Iveco = 59,
  Jaguar = 60,
  Jeep = 61,
  Kawasaki = 62,
  Keeway = 63,
  Kia = 64,
  Kogel = 65,
  Krone = 66,
  Ktm = 67,
  Kymco = 68,
  Lada = 69,
  Lamberet = 70,
  Lamborghini = 71,
  Lancia = 72,
  LandRover = 73,
  Lexus = 74,
  Liebherr = 75,
  Ligier = 76,
  Lincoln = 77,
  Lotus = 78,
  Man = 79,
  Maserati = 80,
  Maybach = 81,
  Mazda = 82,
  Mbk = 83,
  McLaren = 84,
  Mercedes = 85,
  MercedesBenz = 86,
  Mercury = 87,
  Mg = 88,
  Microcar = 89,
  Mini = 90,
  Mitsubishi = 91,
  Morgan = 92,
  MotoGuzzi = 93,
  MvAgust = 94,
  Neoplan = 95,
  Nissan = 96,
  Oldsmobile = 97,
  Opel = 98,
  Oyota = 99,
  Peugeot = 100,
  Piaggio = 101,
  Plymouth = 102,
  Polaris = 103,
  Polestar = 104,
  Polonez = 105,
  Pontiac = 106,
  Porsche = 107,
  Ram = 108,
  Regal = 109,
  Renault = 110,
  RollsRoyce = 111,
  Rover = 112,
  Saab = 113,
  Saturn = 114,
  Scania = 115,
  Schmitz = 116,
  Seat = 117,
  Seegway = 118,
  Setra = 119,
  Skoda = 120,
  Smart = 121,
  SsangYoung = 122,
  Subaru = 123,
  Suzuki = 124,
  Tesla = 125,
  Toyota = 126,
  Triumph = 127,
  VanHool = 128,
  Vespa = 129,
  Volkswagen = 130,
  Volvo = 131,
  Waltra = 132,
  Wielton = 133,
  Yamaha = 134
}
